import { API_ROOT } from "./constants";
import { $user } from "./UserFactory";

// URLs sent via `Socket.emit("get", obj, ...)` are routed by Sails on the
// BE side, not by the CRA dev-server HTTP proxy. So they must NOT carry
// the "/api" prefix that we use for HTTP requests in dev (the proxy
// strips that prefix before forwarding to the BE; sails-io would
// otherwise hit non-existent routes like "/api/badge/subscribe").
//
// When `API_ROOT` is absolute (prod, `https://app.kjuup.de`), we keep it
// — sails-io will use it verbatim and the BE's router only sees the
// pathname. When `API_ROOT` is the relative dev placeholder ("/api"),
// we use an empty prefix so the path is just "/badge/subscribe" etc.
export const SOCKET_BASE = (typeof API_ROOT === "string" && /^https?:\/\//i.test(API_ROOT))
    ? API_ROOT
    : "";

export const badgeObj = {
    url: `${SOCKET_BASE}/badge/subscribe`,
    method: 'get',
    headers: {
        Authorization: `jwt ${$user.getToken()}`
    }
};
// Built per call: the access token rotates every hour, and the server only
// adds this socket to the owner's mailbox room for a valid one. The constant
// objects in this file captured the token once, at import time.
export function buildBadgeSubscribeRequest() {
    return {
        url: `${SOCKET_BASE}/badge/subscribe`,
        method: 'get',
        headers: {
            Authorization: `jwt ${$user.getToken()}`
        }
    };
}

export const badgeUnsubscribeObj = {
    url: `${SOCKET_BASE}/badge/unsubscribe`,
    method: 'get',
    headers: {
        Authorization: `jwt ${$user.getToken()}`
    }
};
export const badgeCountObj = {
    url: `${SOCKET_BASE}/badge/count`,
    method: 'get',
    headers: {
        Authorization: `jwt ${$user.getToken()}`
    }
};

export const onlineObj = {
    url: `${SOCKET_BASE}/user/isOnline`,
    method: 'get',
    headers: {
        Authorization: `jwt ${$user.getToken()}`
    },
};

export const sumTotalChatHistory = arr => arr.reduce((sum, { items }) => sum + items?.length, 0)
